import React from 'react';
export function Footer() {
  return <footer className="bg-dark border-t border-gold/15 p-[40px_25px] md:p-[60px] text-center" data-id="element-148">
      <div className="font-cinzel text-[1.8rem] font-black text-gold tracking-[6px] uppercase mb-2.5" data-id="element-149">
        SOLIDO TATTOO STUDIO
      </div>
      <div className="text-[0.65rem] tracking-[5px] uppercase text-gray mb-[40px]" data-id="element-150">
        Art Lives on Skin · Miami, Florida
      </div>

      <div className="flex justify-center gap-[30px] mb-[40px] flex-wrap" data-id="element-151">
        {['Nosotros', 'Estilos', 'Estudio', 'Galería', 'Opiniones', 'Reservar', 'Ubicación'].map(item => <a key={item} href={`#${item.toLowerCase() === 'nosotros' ? 'about' : item.toLowerCase() === 'estilos' ? 'styles' : item.toLowerCase() === 'estudio' ? 'studio' : item.toLowerCase() === 'galería' ? 'gallery' : item.toLowerCase() === 'opiniones' ? 'testimonials' : item.toLowerCase() === 'reservar' ? 'booking' : 'map-section'}`} className="text-[0.7rem] tracking-[3px] uppercase text-gray transition-colors duration-300 hover:text-gold" data-id="element-152">
            {item}
          </a>)}
      </div>

      <div className="text-[0.7rem] text-gray/50 tracking-[2px] uppercase" data-id="element-153">
        © 2022 · Miami, FL · All Rights Reserved
      </div>
    </footer>;
}